// extracted by mini-css-extract-plugin
module.exports = {"welcome":"HowToPlay_welcome__zmeVa","highlight":"HowToPlay_highlight__3BvcY","big":"HowToPlay_big__3JM1Z","reds":"HowToPlay_reds__1T7oF","blues":"HowToPlay_blues__341hL"};